<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.container.no" placeholder="placeholder.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query.operationType" :options="operationTypes" placeholder="placeholder.operationType" @change="refresh"/>
        <vxe-select v-model="query.commandStatus" :options="commandStatus" placeholder="placeholder.commandStatus" @change="refresh"/>
        <vxe-input v-model="query.workstation.no" :editable="false" placeholder="business.label.workstation" @clear="onWorkstationChange([])" @click="onWorkstationSelect"/>
        <vxe-select v-model="query.error" :options="options" placeholder="business.label.error" @change="refresh"/>
        <vxe-select v-model="query.checked" :options="options" placeholder="button.sending" @change="refresh"/>
        <vxe-button-group style="margin-left: 2px">
          <vxe-button :loading="loading" content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
          <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        </vxe-button-group>
      </template>
      <template #extra>
        <vxe-input v-model="query.wave" placeholder="输入波次或多选明细"/>
        <vxe-button content="button.sending" icon="vxe-icon-send" status="danger" style="margin-top: -4px;margin-left: 8px" @click="send"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading" @checkbox-change="selectChangeEvent" @checkbox-all="selectAllEvent">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="command.operationType" title="business.label.operationType" width="70"/>
        <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
        <vxe-column field="sourceLocation.roadway" title="business.label.sourceRoadway" width="60"/>
        <vxe-column field="sourceLocation.no" title="business.label.sourceLocation" width="120"/>
        <vxe-column field="targetLocation.roadway" title="business.label.targetRoadway" width="80"/>
        <vxe-column field="targetLocation.no" title="business.label.targetLocation" width="120"/>
        <vxe-column field="workstation.name" title="business.label.workstation" width="100"/>
        <vxe-column field="command.orderOfPicking" title="business.label.priority" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:commandStatus}" field="command.commandStatus" title="business.label.commandStatus" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.activated" title="business.label.activated" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.checked" title="business.label.sent" width="60"/>
        <vxe-column field="command.wave" title="business.label.wave" width="100"/>
        <vxe-column field="command.id" title="business.label.commandId" width="180"/>
        <vxe-column field="command.errorMessage" title="business.label.errorMessage"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button v-if="[1,8].includes(row.command?.operationType)" content="button.inboundScan" icon="vxe-icon-arrow-left" status="primary" @click.stop="scan(row)"/>
            <vxe-button v-if="[1,8].includes(row.command?.operationType)" content="button.inboundComplete" icon="vxe-icon-home-page" status="primary" @click.stop="putaway(row)"/>
            <vxe-button v-if="[2,3,4,5,9,10].includes(row.command?.operationType)" content="button.outboundTaken" icon="vxe-icon-arrow-right" status="primary" @click.stop="fetch(row)"/>
            <vxe-button v-if="[2,3,4,5,9,10].includes(row.command?.operationType)" content="button.outboundComplete" icon="vxe-icon-end-page" status="primary" @click.stop="arrive(row)"/>
            <vxe-button v-if="[2,3,4,5,9,10].includes(row.command?.operationType)" content="button.goBack" icon="vxe-icon-undo" status="primary" @click.stop="goback(row)"/>
            <vxe-button v-if="[2,3,4,5,9,10].includes(row.command?.operationType)" content="button.increasePriority" icon="vxe-icon-arrows-up" status="primary" @click.stop="promote(row)"/>
            <vxe-button v-if="[2].includes(row.command?.operationType)" content="button.bindSeedingPosition" icon="vxe-icon-link" status="primary" @click.stop="bindSeedingPosition(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <zone-modal ref="zoneModal" :title="'工作站检索'" @change="onWorkstationChange"/>
    <inbound-scan ref="inboundScanModal" @success="refresh"/>
    <inbound-complete ref="inboundCompleteModal" @success="refresh"/>
    <seeding-position-bind ref="seedingPositionBindModal" @success="refresh"/>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import InboundScan from '@/views/operation/deive_monitor/modal/InboundScanModal.vue'
import InboundComplete from '@/views/operation/deive_monitor/modal/InboundCompleteModal.vue'
import SeedingPositionBind from '@/views/operation/deive_monitor/modal/SeedingPositionBindModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import { ContainerCommand } from '@/api/dto/command/ContainerCommand'
import { Zone } from '@/api/dto/common/Zone'
import { getEnums } from '@/utils/util'

export default {
  components: { SeedingPositionBind, InboundComplete, InboundScan, ZoneModal },
  data() {
    return {
      loading: false,
      data: [],
      operationTypes: [],
      commandStatus: [],
      options: [
        { label: this.$t('business.label.true'), value: true },
        { label: this.$t('business.label.false'), value: false }
      ],
      page: 1,
      size: 20,
      contentSize: 0,
      query: new ContainerCommand(),
      selectedRows: []
    }
  },
  created() {
    getEnums('OperationType').then(result => {
      this.operationTypes = result
      return getEnums('CommandStatus')
    }).then(result => {
      this.commandStatus = result.filter(item => item.ordinal === 0 || item.ordinal === 63 || item.ordinal === 64 || item.ordinal === 65 || item.ordinal === 66 || item.ordinal === 99)
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    selectAllEvent({ checked }) {
      this.selectedRows = this.$refs.table.getCheckboxRecords()
    },
    selectChangeEvent({ checked }) {
      this.selectedRows = this.$refs.table.getCheckboxRecords()
    },
    onWorkstationSelect() {
      this.$refs.zoneModal.open({ 'workstation': true })
    },
    onWorkstationChange(values) {
      this.query.workstation = new Zone(values[0])
      this.refresh()
    },
    refresh() {
      this.loading = true
      const args = {
        'container.no': this.query.container.no,
        operationType: this.query.operationType,
        commandStatus: this.query.commandStatus,
        'zone.no': this.query.workstation.no,
        error: this.query.error,
        checked: this.query.checked,
        wave: this.query.wave
      }
      findAll('automationMonitorFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    scan(row) {
      this.$refs.inboundScanModal.open(row)
    },
    putaway(row) {
      this.$refs.inboundCompleteModal.open(row)
    },
    fetch(row) {
      const args = { 'command.id': row.command.id }
      post(api.containerFetch, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    arrive(row) {
      const args = { 'container.no': row.container.no }
      post(api.containerArrive, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    goback(row) {
      const args = { 'container.no': row.container.no }
      post(api.containerGoback, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    promote(row) {
      const args = { 'id': row.command.id }
      post(api.commandPromote, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    bindSeedingPosition(row) {
      this.$refs.seedingPositionBindModal.open(row)
    },
    send() {
      const args = {
        wave: this.query.wave,
        ids: this.selectedRows.map(row => row.command.id)
      }
      post(api.containerSend, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.query = new ContainerCommand()
      this.refresh()
    }
  }
}
</script>